// frontend/src/modules/empresas/pages/GerenciarEmpresas.js
import React, { useState, useEffect } from 'react';
import { FaEdit, FaToggleOn, FaToggleOff, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

function GerenciarEmpresas() {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const token = localStorage.getItem('token');

  const fetchEmpresas = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch('/api/empresas', {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Erro:', errorText);
        throw new Error(`Erro ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      console.log('📦 Empresas carregadas:', data.length);
      setEmpresas(data);
    } catch (err) {
      console.error('❌ Erro detalhado:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmpresas();
  }, []);

  const toggleStatus = async (id, ativo) => {
    try {
      const response = await fetch(`/api/empresas/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ ativo: !ativo })
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Erro ao atualizar');
      }

      fetchEmpresas();
      alert(`Empresa ${!ativo ? 'ativada' : 'desativada'} com sucesso!`);
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>🔄 Carregando empresas...</div>;
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <div style={{ fontSize: '48px', marginBottom: '10px' }}>❌</div>
        <p style={{ color: 'red', fontSize: isMobile ? '14px' : '16px' }}>Erro: {error}</p>
        <button 
          onClick={fetchEmpresas}
          style={{ 
            marginTop: '10px', 
            padding: isMobile ? '8px 20px' : '10px 20px', 
            backgroundColor: '#007bff', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            fontSize: isMobile ? '13px' : '14px',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          Tentar Novamente
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: isMobile ? '10px' : '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Cabeçalho */}
      <div style={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between', 
        alignItems: isMobile ? 'stretch' : 'center', 
        marginBottom: '20px',
        flexWrap: 'wrap',
        gap: '10px'
      }}>
        <div>
          <h2 style={{ margin: 0, fontSize: isMobile ? '20px' : '28px' }}>🏢 Gerenciar Empresas</h2>
          <p style={{ color: '#6c757d', margin: '5px 0 0 0', fontSize: isMobile ? '13px' : '14px' }}>
            Gerencie todas as empresas cadastradas na plataforma
          </p>
        </div>
        <button 
          onClick={() => navigate('/register')}
          style={{ 
            padding: isMobile ? '8px 16px' : '10px 20px', 
            backgroundColor: '#28a745', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'center',
            fontSize: isMobile ? '13px' : '14px',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <FaPlus /> Nova Empresa
        </button>
      </div>

      {/* Lista de Empresas */}
      <div style={{ backgroundColor: 'white', padding: isMobile ? '10px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', overflowX: 'auto' }}>
        {empresas.length === 0 ? (
          <div style={{ textAlign: 'center', padding: isMobile ? '30px' : '40px' }}>
            <div style={{ fontSize: isMobile ? '36px' : '48px', marginBottom: '10px' }}>🏢</div>
            <p style={{ color: '#6c757d', fontSize: isMobile ? '13px' : '14px' }}>Nenhuma empresa cadastrada.</p>
            <button 
              onClick={() => navigate('/register')}
              style={{ 
                marginTop: '10px', 
                padding: isMobile ? '8px 20px' : '8px 20px', 
                backgroundColor: '#28a745', 
                color: 'white', 
                border: 'none', 
                borderRadius: '4px', 
                cursor: 'pointer',
                fontSize: isMobile ? '13px' : '14px',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              <FaPlus /> Cadastrar primeira empresa
            </button>
          </div>
        ) : isMobile ? (
          // ============================================
          // MOBILE - CARDS
          // ============================================
          <div>
            {empresas.map(empresa => (
              <div
                key={empresa.id}
                style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  padding: '12px',
                  marginBottom: '10px',
                  borderLeft: `4px solid ${empresa.ativo ? '#28a745' : '#dc3545'}`
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                  <strong style={{ fontSize: '14px' }}>{empresa.nome_empresa}</strong>
                  <span style={{
                    padding: '2px 8px',
                    borderRadius: '10px',
                    backgroundColor: empresa.ativo ? '#d4edda' : '#f8d7da',
                    color: empresa.ativo ? '#155724' : '#721c24',
                    fontSize: '10px'
                  }}>
                    {empresa.ativo ? '✅ Ativo' : '❌ Inativo'}
                  </span>
                </div>
                <div style={{ fontSize: '12px', color: '#6c757d' }}>
                  <div><strong>CNPJ:</strong> {empresa.cnpj}</div>
                  <div><strong>Email:</strong> {empresa.email}</div>
                  {empresa.nome_fantasia && (
                    <div><strong>Fantasia:</strong> {empresa.nome_fantasia}</div>
                  )}
                </div>
                <div style={{ marginTop: '8px', display: 'flex', gap: '8px', justifyContent: 'flex-end', borderTop: '1px solid #dee2e6', paddingTop: '8px' }}>
                  <button 
                    onClick={() => navigate(`/editar-empresa/${empresa.id}`)}
                    style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer' }}
                    title="Editar empresa"
                  >
                    <FaEdit size={14} />
                  </button>
                  <button 
                    onClick={() => toggleStatus(empresa.id, empresa.ativo)}
                    style={{ background: 'none', border: 'none', color: empresa.ativo ? '#dc3545' : '#28a745', cursor: 'pointer' }}
                    title={empresa.ativo ? 'Desativar' : 'Ativar'}
                  >
                    {empresa.ativo ? <FaToggleOn size={20} /> : <FaToggleOff size={20} />}
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          // ============================================
          // DESKTOP - TABELA
          // ============================================
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>ID</th>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Empresa</th>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>CNPJ</th>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Email</th>
                <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #dee2e6' }}>Status</th>
                <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #dee2e6' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {empresas.map(empresa => (
                <tr key={empresa.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                  <td style={{ padding: '10px' }}>{empresa.id}</td>
                  <td style={{ padding: '10px' }}>
                    <strong>{empresa.nome_empresa}</strong>
                    {empresa.nome_fantasia && (
                      <span style={{ color: '#6c757d', fontSize: '12px', display: 'block' }}>
                        {empresa.nome_fantasia}
                      </span>
                    )}
                  </td>
                  <td style={{ padding: '10px' }}>{empresa.cnpj}</td>
                  <td style={{ padding: '10px' }}>{empresa.email}</td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>
                    <span style={{
                      padding: '3px 10px',
                      borderRadius: '12px',
                      backgroundColor: empresa.ativo ? '#d4edda' : '#f8d7da',
                      color: empresa.ativo ? '#155724' : '#721c24'
                    }}>
                      {empresa.ativo ? '✅ Ativo' : '❌ Inativo'}
                    </span>
                  </td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>
                    <button 
                      onClick={() => navigate(`/editar-empresa/${empresa.id}`)}
                      style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', marginRight: '10px' }}
                      title="Editar empresa"
                    >
                      <FaEdit size={18} />
                    </button>
                    <button 
                      onClick={() => toggleStatus(empresa.id, empresa.ativo)}
                      style={{ background: 'none', border: 'none', color: empresa.ativo ? '#dc3545' : '#28a745', cursor: 'pointer' }}
                      title={empresa.ativo ? 'Desativar' : 'Ativar'}
                    >
                      {empresa.ativo ? <FaToggleOn size={24} /> : <FaToggleOff size={24} />}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        
        {empresas.length > 0 && (
          <div style={{ marginTop: '15px', textAlign: 'right', fontSize: isMobile ? '12px' : '14px', color: '#6c757d' }}>
            Total: {empresas.length} empresa(s)
          </div>
        )}
      </div>
    </div>
  );
}

export default GerenciarEmpresas;